<template>
  <div class="diamonds" :class="{printing: printing}">
    <div class="printBtn">
      <div class="btn" v-if="!printing" @click="startPrint" ><p>Print</p></div>
      <div class="btn" v-if="!printing" @click="startDownload()" ><p>Download Pdf</p></div>
    </div>
    <div class="pamphlet">
      <div class="header">
        <div ref="loader"></div>
      </div>
      <div class="pamphlet-holder" id="pamphlet-holder" :class="{printing: printing}">
        <canvas class="canvas" id="canvas" width="1344" height="816"></canvas>
          <div v-if='!printing' class="certificate-background">
            <img src="https://firebasestorage.googleapis.com/v0/b/diamonds-8cf72.appspot.com/o/report%20(1).png?alt=media&token=8f8b2c64-eb41-411c-b181-9a5f7fa21105" alt="certificate">
          </div>
          <div width="1344" height="816" ref="canvasimg" v-if="imperfection" class="sections" id="sections" :class="{printing: printing}">
            <!-- <vue-html2pdf
              :show-layout="false"
              :enable-download="true"
              :filename="diamond.id"
              :pdf-quality="2"
              :manual-pagination='true'
              pdf-format="a4"
              pdf-orientation="landscape"
              pdf-content-width="1050px"
              @hasGenerated="pdfDownloaded($event)"
              ref="pdfDownload"
            > -->
            <section slot="pdf-content" ref="pdfDownload" id="pdfDownload" :class="{downloading_pdf: downloading_pdf}">
              <div id='sections-holder'>

              <img style='width: 1040px !important' v-if='downloading_pdf' class='background' src="@/assets/img/dis3.png" alt="certificate">
                <div class='section1' style="position: absolute; top: 155px; left: 34px; width: 265px;">
                  <p style="margin: 0; font-size: 13px; margin-bottom: -20px; margin-top: 20px;" class="date">{{ diamond.created | moment("MM/D/YYYY") }}</p>
                  <p style="    font-weight: bold; font-size: 13px; text-transform: uppercase; margin-top: 30px;" class='title'>{{diamond.ManufacturedAs == "Natural Stone" ? 'NATURAL DIAMOND GRADING' : 'Lab Grown diamond grading'}}</p>
                  <div class="list">
                    <p>DIS Report Number</p>
                    <p>{{ diamond.CertNum }}</p>
                  </div>
                  <div class="list">
                    <p>Shape and Cutting Style</p>
                    <p>{{ diamond.Shape }} </p>
                  </div>
                  <div class="list">
                    <p>Measurement</p>
                    <p>{{ diamond.Measurements }} </p>
                  </div>
                  <div class='space'></div>
                  <p class='title'>Grading Results</p>
                  <div class="list">
                    <p>Carat Weight</p>
                    <p>{{ diamond.Weight }} CARATS</p>
                  </div>
                  
                  <div class="list">
                    <p>Color Grade</p>
                    <p>{{ diamond.Color.value + diamond.Color.asterisks }} {{getDiamondColor()}}</p> 
                  </div>
                  <div class="list">
                    <p>Clarity Grade</p>
                    <p>{{ diamond.Clarity.value +  diamond.Clarity.asterisks }}</p>
                  </div>
                  <div class="list" v-if="diamond.Cut && diamond.Shape == 'Round'">
                    <p>Cut Grade</p>
                    <p>{{ diamond.Cut || 'N/A' }} </p>
                  </div>

                  <div class='grading_info'>
                    <div class="list">
                      <p>Polish</p>
                      <p>{{ diamond.Polish }}</p>
                    </div>
                    <div class="list">
                      <p>Symmetry</p>
                      <p>{{ diamond.Symmetry }}</p>
                    </div>
                    <div class="list">
                      <p>Fluorescence</p>
                      <p>{{ diamond.Fluorescence }}</p>
                    </div>
                    <div class="list" v-if='diamond.Inscription'>
                      <p>Inscription(s) DIS {{diamond.ManufacturedAs == "Natural Stone" ? 'NATURAL DIAMOND GRADING' : 'Lab Grown diamond'}} {{ diamond.CertNum }}</p>
                      <p> {{ diamond.Inscription || 'N/A' }}</p>
                    </div>
                    <div class="list comments">
                      <p>Comments:</p>
                      <p v-if="!diamond.CertificateComments.includes('<p>')"> {{ diamond.CertificateComments }} </p>
                      <p v-else v-html='diamond.CertificateComments'> </p>
                    </div>
                  </div>
                </div>

                <div class='section2'>
                  <p class='CertNum'>{{ diamond.CertNum }}</p>
                  <p class='website_text'>Verify DIS Certificate at www.diamondservicesusa.com</p>
                  <p class='title'>Proportions</p>
                  <img id="proportion_url" ref='proportion_url' class="proportions_image" :src="imperfection.proportions_image" alt="Proportions Image">
                  
                  <div class="imperfection_img">
                      <img
                      class='img'
                      :src="imperfection.url"
                      alt="Imperfection Template"
                      ref="characteristics_url"
                      id="characteristics_url"
                      />
                      <div class="imperfections_key_holder">
                        <p class="imperfection_chosen_text section_two_section_head">
                        Key to Symbols
                        </p>
                        <div v-if="!imperfection.imperfectionAddedList" class="key_info_holder">
                          <template v-if='imperfection.display_imperfection_icons'>
                            <div 
                              v-if="!diamond.add_imperfection_icons"
                              class="imperfections_key"
                              v-for="(imperfection, index) in imperfection.imperfections"
                              :key="index"
                              >
                              <img
                              ref='imperfection_url'
                                  class="imperfection_img_icon"
                                  :src="
                                  require('@/assets/img/imperfections/' + imperfection.image)
                                  "
                                  alt="imperfection"
                              />
                              <p class="imperfections_key_text">{{ imperfection.name }}</p>
                            </div>
                          </template>
                          <div v-if="!imperfection.display_imperfection_icons" class="imperfections_key_noicon">
                            <p>
                              Red Symbols indicate internal characteristics.<br></br>
                              Green symbols indicate external characteristics
                            </p>
                          </div>
                        </div>
                        <div v-if="imperfection.imperfectionAddedList" class="key_info_holder">
                          <template v-if='imperfection.display_imperfection_icons'>
                          <div 
                            v-if="!diamond.add_imperfection_icon"
                            class="imperfections_key"
                            v-for="(imperfection, index) in imperfection.imperfectionAddedList"
                            :key="index"
                            >
                            <img
                            ref='imperfection_url'
                                class="imperfection_img_icon"
                                :src="
                                require('@/assets/img/imperfections/' + imperfection.image)
                                "
                                alt="imperfection"
                            />
                            <p class="imperfections_key_text">{{ imperfection.name }}</p>
                          </div>
                          </template>
                          <div v-if="!imperfection.display_imperfection_icons" class="imperfections_key_noicon">
                            <p>
                              Red Symbols indicate internal characteristics. <br></br>
                              Green symbols indicate external characteristics
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                            </div>

                <vue-qr
                  class='qr_code'
                  :size="110"
                  :text="diamond.CertificateVideo.url">
                </vue-qr>
              </section>
              <!-- </vue-html2pdf> -->

              <div class='section4'>
                <p class="list date section_four_date">{{ diamond.created | moment("MM/D/YYYY") }}</p>
                <p class='title'>{{diamond.ManufacturedAs == "Natural Stone" ? 'NATURAL DIAMOND GRADING' : 'Lab Grown diamond grading'}} </p>
                <div class="list">
                  <p>DIS Report Number</p>
                  <p>{{ diamond.CertNum }}</p>
                </div>
                <div class="list">
                  <p>Shape</p>
                  <p>{{ diamond.Shape }} </p>
                </div>
                <div class="list">
                  <p>Measurements</p>
                  <p>{{ diamond.Measurements }} </p>
                </div>

                <div class='space'></div>
                <div class="list ">
                  <p>Carat Weight</p>
                  <p>{{ diamond.Weight }} CARATS</p>
                </div>
                
                <div class="list">
                  <p>Color Grade</p>
                  <p>{{ diamond.Color.value + diamond.Color.asterisks }} {{getDiamondColor()}}</p> 
                </div>
                <div class="list">
                  <p>Clarity Grade</p>
                  <p>{{ diamond.Clarity.value +  diamond.Clarity.asterisks }}</p>
                </div>
                <div class="list" v-if="diamond.Cut && diamond.Shape == 'Round'">
                  <p>Cut Grade</p>
                  <p>{{ diamond.Cut ? diamond.Cut : 'N/A' }} </p>
                </div>
                
                <div class='space'></div>
                <p class='title'>GRADING RESULTS</p>
                <div class="list ">
                  <p>Polish</p>
                  <p>{{ diamond.Polish }}</p>
                </div>
                <div class="list">
                  <p>Symmetry</p>
                  <p>{{ diamond.Symmetry }}</p>
                </div>
                <div class="list">
                  <p>Fluorescence</p>
                  <p>{{ diamond.Fluorescence }}</p>
                </div>

                <div class="list inscription" v-if='diamond.Inscription'>
                  <p>Inscription(s)</p>
                  <p>  {{ diamond.Inscription ? diamond.Inscription : 'N/A' }} </p>
                </div>
                <div class="list comments">
                  <p class='comment-title'>Comments</p>
                  <p class="text_import blue" v-if="!diamond.CertificateComments.includes('<p>')"> {{ diamond.CertificateComments }} </p>
                  <p class="text_import blue" v-else v-html='diamond.CertificateComments'> </p>
                </div>

            </div>

            <div class="section_four_rotated">
                  <p class="date">{{ diamond.created | moment("MM/D/YYYY") }}</p>
                
                  <div class="list">
                    <p>DIS Report Number</p>
                    <p>{{ diamond.CertNum }}</p>
                  </div>
                  <div class="list">
                    <p>Carat Weight</p>
                    <p>{{ diamond.Weight }} CARATS</p>
                  </div>
                  <div class="list">
                    <p>Color Grade</p>
                    <p>{{ diamond.Color.value + diamond.Color.asterisks }} {{getDiamondColor()}}</p> 
                  </div>
                  <div class="list">
                    <p>Clarity Grade</p>
                    <p>{{ diamond.Clarity.value +  diamond.Clarity.asterisks}}</p>
                  </div>
                  <div class="list" v-if="diamond.Cut && diamond.Shape == 'Round'">
                  <p>Cut Grade</p>
                  <p>{{ diamond.Cut || 'N/A' }} </p>
                </div>
                  <div class="list" v-if='diamond.Depth'>
                    <p>Depth</p>
                    <p>{{ diamond.Depth || 'N/A' }}</p>
                  </div>
                  <div class="list" v-if='diamond.Table'>
                    <p>Table</p>
                    <p>{{ diamond.Table || 'N/A' }}</p>
                  </div>
                  <div class="list" v-if='diamond.Girdle'>
                    <p>Girdle</p>
                    <p>{{ diamond.Girdle || 'N/A' }}</p>
                  </div>
                  <!-- <div class="list" v-if='diamond.culet'>
                    <p>Culet</p>
                    <p>{{ diamond.culet ? diamond.culet : 'N/A' }}</p>
                  </div> -->
                  <div class="list">
                    <p>Polish</p>
                    <p>{{ diamond.Polish }}</p>
                  </div>
                  <div class="list">
                    <p>Symmetry</p>
                    <p>{{ diamond.Symmetry }}</p>
                  </div>
                  <div class="list">
                    <p>Fluorescence</p>
                    <p>{{ diamond.Fluorescence }}</p>
                  </div>

                  <div class="list" v-if='diamond.Inscription'>
                    <p>Inscription(s)</p>
                    <p>  {{ diamond.Inscription ? diamond.Inscription  : 'N/A' }} </p>
                  </div>
                  <div class="list rotated_comments">
                    <p class='comment-title'>Comments</p>
                    <p class="text_import blue" v-if="!diamond.CertificateComments.includes('<p>')"> {{ diamond.CertificateComments }} </p>
                    <p class="text_import blue" v-else v-html='diamond.CertificateComments'> </p>
                  </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, storage, functions, auth } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import Vue from "vue";
import printJS from "print-js";
import firebase from "firebase";
import VueQr from "vue-qr";
import html2pdf from "html2pdf.js";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
  ],
};
Vue.use(require("vue-moment"));
export default {
  name: "home",
  components: {
    'vue-qr': VueQr,
  },

  data() {
    return {
      downloading_pdf: false,
      ratio: null,
      printLoader: null,
      generated: false,
      pamphlet_diamond: null,
      canvas: null,
      diamond: null,
      imperfection: null,
      savedDiamonds: [],
      connect_clicked: false,
      connect_diamond: null,
      tableData: [],
      printing: false,
      colors: {
        Standard: {
          key: "",
          name: "",
          value: [
            "Z",
            "Y",
            "X",
            "W",
            "V",
            "U",
            "T",
            "S",
            "R",
            "Q",
            "P",
            "O",
            "N",
            "M",
            "L",
            "K",
            "J",
            "I",
            "H",
            "G",
            "F",
            "E",
            "D",
          ],
        },
        Blue: {
          name: "Blue",
          value: [
            "Light",
            "Fancy Light",
            "Fancy",
            "Fancy Intense",
            "Fancy Vivid",
          ],
          key: "_B_",
        },
        Brown: {
          name: "Brown",
          value: ["C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8"],
          key: "_B_",
        },
        Green: {
          name: "Green",
          value: [
            "Faint",
            "Very Light",
            "Light",
            "Fancy Light",
            "Fancy",
            "Fancy Intense",
            "Fancy Vivid",
            "Fancy Deep",
          ],
          key: "_G_",
        },
        Pink: {
          name: "Pink",
          value: [
            "Faint",
            "Very Light",
            "Light",
            "Fancy Light",
            "Fancy",
            "Fancy Intense",
            "Fancy Vivid",
            "Fancy Deep",
          ],
          key: "_P_",
        },
        Yellow: {
          name: "Yellow",
          value: ["Fancy Light", "Fancy", "Intense", "Vivid", "Deep"],
          key: "_Y_",
        },
        Black: {
          name: "Black",
          value: ["A", "AA", "AAA", "AAAA"],
          key: "_B_",
        },
        Red: {
          name: "Red",
          value: [
            "Faint",
            "Fancy",
            "Fancy Dark",
            "Fancy Intense",
            "Fancy Light",
            "Fancy Vivid",
            "Light",
            "Very Light",
          ],
          key: "_R_",
        },
      }
    };
  },
  async created() {
    let loader = this.$loading.show({
      container: this.$refs.loader,
      canCancel: false,
    });

    let query = await db
      .collection("diamond")
      .where("imperfection.id", "==", this.$route.params.id)
      .get();

    if (!query.size) {
      loader.hide();
      return Swal.fire(
        "",
        "There's an error retrieving data. Please try again",
        "error"
      ).then(() => {
        this.$router.go(-1);
      });
    }

    this.diamond = Object.assign(
      { id: query.docs[0].id },
      query.docs[0].data()
    );
    let imperfection_doc = await db
      .collection("diamond_imperfections")
      .doc(this.diamond.imperfection.id)
      .get();

    if (imperfection_doc.exists) {
      this.imperfection = Object.assign(
        { id: imperfection_doc.id },
        imperfection_doc.data()
      );
      loader.hide();
    } else {
      loader.hide();
      return Swal.fire("", "No Imperfections ", "error").then(() => {
        this.$router.go(-1);
      });
    }
    this.calcResizeRatio();
  },
  watch: {
    imperfection() {
      this.$nextTick(() => {
        if (this.imperfection && !this.generated) {
          this.generated = true;
          setTimeout(()=> {
            this.convertImages();
          }, 1000)
        }
      });
    },
  },
  methods: {
    getDiamondColor(){
      let color = ''
      if (this.diamond.Color.template) {
       if (this.colors[this.diamond.Color.template].value.includes(this.diamond.Color.value)){
            color = this.colors[this.diamond.Color.template].name
          }
      }
      return color
    },
    calcResizeRatio() {
      this.$nextTick(() => {
        let windowHeight = window.innerHeight;
        let windowWidth = window.innerWidth;
        let heightRatio = windowHeight / 3000;
        let widthRatio = windowWidth / 4500;

        // if (heightRatio < widthRatio) {
        //   this.ratio = heightRatio;
        // } else this.ratio = widthRatio;
        this.ratio = widthRatio;
      });
    },
    async convertImages() {
      let loader = this.$loading.show({
        container: this.$refs.loader,
        canCancel: false,
      });

      //Using refs to fetch data url
      let imperfection_img = this.imperfection.url;
      let porportion_img = await this.getImage(
        this.imperfection.proportions_ref
      );

      //Converting download url to blobs
      let imperfection_blob = await this.convertImageToBlob(imperfection_img);
      let proportion_blob = await this.convertImageToBlob(porportion_img);

      //Converting Blobs to DataURL
      // let imperfection_url = await this.blobToDataURL(imperfection_blob);
      // let proportion_url = await this.blobToDataURL(proportion_blob);
      // this.$refs.characteristics_url.src = imperfection_url
      // this.$refs.proportion_url.src = proportion_url
      
      // document.getElementById('characteristics_url').src = imperfection_url;
      // document.getElementById('proportion_url').src = proportion_url;

      this.printLoader = loader;
      // this.print();
      loader.hide();
    },
    startPrint(){
      this.printing = true;
      // let loader = this.$loading.show({
      //   container: this.$refs.loader,
      //   canCancel: false,
      // });
      // this.print(loader);
      setTimeout(() => {
        window.print()
      }, 300);
    },
    startDownload(){
      let loader = this.$loading.show({
      container: this.$refs.loader,
      canCancel: false,
    });
      this.downloading_pdf = true;
      let vm = this;
      var opt = {
        margin: [-.3, .3,0,0],
        filename:
          "Certificate #"+this.diamond.CertNum+".pdf",
        image: { type: "jpeg", quality: .5 },
        html2canvas: { scale: 2, useCORS: true, height: 800 },
        jsPDF: { unit: "in", orientation: "landscape",}
      };
      window.scrollTo(0, 0);
      document.getElementById('sections-holder').style.transform = 'scale(.9)';
      document.getElementsByClassName('qr_code')[0].style.top = '390px';
      document.getElementsByClassName('qr_code')[0].style.left = '796px';
      document.getElementsByClassName('qr_code')[0].style.position = 'absolute';
      setTimeout(() => {
        html2pdf()
          .from(this.$refs.pdfDownload)
          .set(opt).then(()=> {
            setTimeout(() => {
              loader.hide()
              vm.downloading_pdf = false;
              document.getElementById('sections-holder').style.transform = 'scale(1)';
              document.getElementsByClassName('qr_code')[0].style.top = '390px';
              document.getElementsByClassName('qr_code')[0].style.left = '829px';
              document.getElementsByClassName('qr_code')[0].style.position = 'absolute';
            }, 500);
          })
          .save();
      }, 500);
    },
    getImage(ref) {
      return storage
        .refFromURL("gs://diamonds-8cf72.appspot.com/" + ref)
        .getDownloadURL()
        .then(function (url) {
          return url;
        })
        .catch(function (error) {
          alert("Could not load your design. Please reload and try again.");
        });
    },
    async convertImageToBlob(img) {
      return fetch(img).then((url) => url.blob());
    },
    blobToDataURL(blob, obj) {
      let vm = this;
      return new Promise((fulfill, reject) => {
        let reader = new FileReader();
        reader.onerror = reject;
        reader.onload = (e) => fulfill(reader.result);
        reader.readAsDataURL(blob);
      })
        .then((logo) => {
          return logo;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async dataURLToDownloadUrl(DataURL) {
      var storage = firebase.storage();
      var storageRef = storage.ref("diamond_imperfections/" + Date.now());
      let ref = await storageRef
        .putString(DataURL, "data_url")
        .then(function (snapshot) {
          return snapshot.ref.getDownloadURL().then((downloadURL) => {
            return { ref: snapshot.metadata.fullPath, url: downloadURL };
          });
        });
      return ref;
    },
    async print(loader) {
      const decrement = firebase.firestore.FieldValue.increment(-1);
      const increment = firebase.firestore.FieldValue.increment(1);
      var dataURL = await this.convertToDataURL();
      let img = dataURL.toDataURL("image/jpeg", 0.1);
      let downloadURL = await this.dataURLToDownloadUrl(img);
      let created = new Date().toLocaleString();
      return printJS({
        printable: img,
        type: "image",
        showModal: true,
        onPrintDialogClose: this.closedWindow,
      });
    },
    convertToDataURL() {
      const el = this.$refs.canvasimg;
      const options = {
        scrollY: -window.scrollY,
      };
      return this.$html2canvas(el, options);
    },
    closedWindow() {
      this.$router.go(-1);
    },
    getDiamonds() {
      let vm = this;
      db.collection("diamond_imperfections")
        .get()
        .then(function (querySnapshot) {
          vm.savedDiamonds = [];
          querySnapshot.forEach(function (doc) {
            vm.savedDiamonds.push({
              name: doc.data().name,
              diamond_cut: doc.data().diamond_cut,
              image_ref: doc.data().image_ref,
              imperfections: doc.data().imperfections,
              id: doc.id,
              //   url: doc.data().url,
            });
          });
        });
    },
    viewImage(diamond) {
      let ref = storage.ref(diamond.image_ref);
      ref
        .getDownloadURL()
        .then(function (url) {
          window.open(url, "_blank");
        })
        .catch(function (error) {
          alert(error.code);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@page {
  size: landscape;
  margin: 10%;
}

.diamonds.printing {
  position: fixed;
  top: 0;
  left: 0;
  width:100%;
  padding-top: 0;
  z-index: 999999;
  background-color: white;
}

#pamphlet-holder {
  width:1344px;
  margin: auto;
  margin-top: 75px;
  position: relative;
  box-sizing: border-box;
  &.printing {
    margin-top: 0;
  }
}

.certificate-background {
  background: white;
  width: 100%;
  img {
    width: 100%;
  }
}

canvas {
  position: fixed;
  z-index: -2;
}

.printBtn {
  text-align: center;
  padding: 5px;
  position: absolute;
  z-index: 11;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  p {
    font-size: 17px;
    margin-top: 0px;
    font-family: 'Open Sans';
    margin-bottom: 0px;

  }
  .btn {
    margin: 0 25px;
  }
}


.sections {
  position: absolute;
  top: 0;
  left: 0;
  width: 1344px;
  min-height: 500px;
  .title {
    font-weight: bold;
    font-size: 13px;
    text-transform: uppercase;
    margin-top: 30px;
  }
  .list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
    p {
      margin: 0;
      font-size: 12px;
    }
    p:nth-child(1) {
      font-weight: normal;
      margin-right: 15px;
    }
    p:nth-child(2) {
      font-weight: bold;
      text-align: right;
      // & /deep/ p {
      //   margin: 0;
      //   text-align: left !important;
      // }
    }
  }
  .comments {
    flex-direction: column;
    font-weight: unset;
    align-items: flex-start;
    margin-top: 30px;
    // & /deep/ p {
    //   margin: 0;
    //   text-align: left !important;
    // }
  }
  .section1 {
    position: absolute;
    top: 155px;
    left: 34px;
    width: 265px;
    .date {
      margin: 0;
      font-size: 13px;
      margin-bottom: -20px;
      margin-top: 20px;
    }
    .grading_info {
      position: absolute;
      top: 362px;
      left: 0;
      width: 100%;
    }
  }
  .section2 {
    position: absolute;
    top: 155px;
    left: 385px;
    width: 283px;
    .CertNum {
      position: absolute;
      top: -110px;
      font-size: 12px;
      text-align: center;
      left: 40px;
      width: 200px;
    }
    .website_text {
      width: 200px;
      position: absolute;
      top: -80px;
      font-size: 12px;
      text-align: center;
      left: 40px;
      opacity: .5;
    }
    .proportions_image {
      width: 100%;
      max-width: 582px;
      max-height: 550px;
      height: auto;
      margin-bottom: 0px;
      display: flex;
      margin: auto;
      margin-top: 10px;
      background:white;
      max-height: 261px;
      left: 2px;
      position: relative;
    }
    .imperfection_img {
      position: absolute;
      width: 100%;
      top: 362px;
      .img {
        // background: #2b2b2b;
        width: 100%;
        z-index: 2;
        position: relative;
        left: 2px;
      }
      .img_background {
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 1;
        filter: none;
      }
      .imperfections_key_holder {
        margin-left: 0;
        padding-left: 15px;
      }
      .imperfection_chosen_text {
        margin-left: 0;
        font-size: 13px;
        width: 100%;
        margin-top: 0;
        margin-bottom: 5px;
      }
      .key_info_holder {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        .imperfections_key {
          margin: 0;
          width: auto;
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          margin-right: 10px;
          margin-bottom: 5px;
          p {
            font-size: 10px;
            margin: 0;
          }
          img {
            height: 20px;
            margin-left: 3px;
          }
        }
      }
    }
  }
  .qr_code {
    position: absolute;
    top: 390px;
    left: 829px;
  }

  .section4 {
    position: absolute;
    top: 100;
    right: 32px;
    width: 236px;
    height: 630px;
    .date {
      position: relative;
      font-size: 14px;
      margin-top: 20px;
    }
    .imperfections_key_holder {
      margin-left: 0;
    }
  }
  .section_four_rotated {
    transform: rotate(
-90deg
);
    width: 68px;
    position: absolute;
    right: 98px;
    bottom: -400px;
    height: 250px;
      .imperfections_key_holder {
        margin-left: 0;
      }
      .date {
        font-size: 8px;
        margin: 0;
        margin-bottom: 5px;
      }
      .list {
        margin-bottom: 3px;
        p {
          font-size: 6px;
          font-weight: bold !important;
        }
      }
      .rotated_comments {
        display: flex;
        flex-direction: column;
      }
    }
}

.imperfections_key_noicon {
  margin-left: 0;
  padding-top: 0;
  p {
    font-size: 11px;
    margin-top: 0;
  }
}


// For pdf export


.sections .background {
  width: 100% !important;
  position: absolute;
}

.title {
    font-weight: bold;
    font-size: 13px;
    text-transform: uppercase;
    margin-top: 30px;
  }
  .list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
  }
  .list p {
    margin: 0;
    font-size: 12px;
  }
  .list p:nth-child(1) {
    font-weight: normal;
    margin-right: 15px;
  }
  .list p:nth-child(2) {
    font-weight: bold;
    text-align: right;
  }
  .comments {
    flex-direction: column;
    font-weight: unset;
    align-items: flex-start;
    margin-top: 30px;

  }

.downloading_pdf .section1 {
  top: 155px !important;
}

.section1 .grading_info {
  position: absolute;
  top: 362px;
  left: 0;
  width: 100%;
}

.section2 {
  position: absolute;
  top: 155px;
  left: 385px;
  width: 283px;
}

.section2 .CertNum {
  position: absolute;
  top: -110px;
  font-size: 12px;
  text-align: center;
  left: 40px;
  width: 200px;
}

.section2 .website_text{
  width: 200px;
  position: absolute;
  top: -80px;
  font-size: 12px;
  text-align: center;
  left: 40px;
  opacity: 0.5;
}

.section2 .proportions_image {
  width: 100%;
  max-width: 582px;
  max-height: 550px;
  height: auto;
  margin-bottom: 0px;
  display: flex;
  margin: auto;
  margin-top: 10px;
  background: white;
  max-height: 261px;
  left: 2px;
  position: relative;
}

.section2 .imperfection_img {
  position: absolute;
  width: 100%;
  top: 362px;
}

.section2 .imperfection_img .img {
  width: 100%;
  z-index: 2;
  position: relative;
  left: 2px;
}
.section2 .imperfections_key_holder{
  margin-left: 0;
  padding-left: 15px;
}

.section2 .imperfection_chosen_text {
  margin-left: 0;
  font-size: 13px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}

.section2 .imperfection_img .key_info_holder {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.section2 .imperfection_img .key_info_holder .imperfections_key {
  margin: 0;
  width: auto;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 5px;
}

.section2 .imperfection_img .key_info_holder .imperfections_key img {
  height: 20px;
  margin-left: 3px;
}

.section2 .imperfection_img .key_info_holder .imperfections_key p {
  font-size: 10px;
  margin: 0;
}

.section2 .qr_code {
  position: absolute;
  top: 390px;
  left: 829px;
  width: 110px;
  height: 110px;
}

.sections-holder {
  position: relative;
}
</style>

